import { LicenseData } from './LicenseData'

export default LicenseData